module.exports = __webpack_public_path__ + "components/Modals/SideDescription/img/kosciol.jpg?4437e5a1";


//////////////////
// WEBPACK FOOTER
// ./components/Modals/SideDescription/img/kosciol.jpg
// module id = 2428
// module chunks = 0